import React from "react";
import { Link } from "react-router-dom";
import { Label, Button } from "semantic-ui-react";

const AppLink = ({ to, children, ellipsis = true, background, dataTest = "", ...rest }) => {
  return (
    <Link to={to} {...(dataTest === "" ? {} : { "data-test": dataTest })}>
      {background ? (
        <Button color="orange" className="background" {...rest}>
          {children}
        </Button>
      ) : (
        <Label
          className={ellipsis ? "addEllipsis" : ""}
          color="orange"
          basic
          style={{ border: "none", padding: 0, paddingTop: "2%" }}
          {...rest}
        >
          {children}
        </Label>
      )}
    </Link>
  );
};

export default AppLink;
